import { Button, Drawer, Form, Select, Switch } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import AddTimeSlot from "./AddTimeSlot";
import TimeSlotDetails from "./Details";
import { responseNotification } from "../../utils/notify";
import moment from "moment";
import { debounce } from "lodash";
const { Option } = Select;

const TimeSlotList = () => {
  const fetchRef = useRef(0);
  const [limit, setLimit] = useState(16);
  const [locationId, setLocationId] = useState<any>();

  const [slotData, setSlotData] = useState({
    loading: false,
    data: null,
  });

  const [locationOptions, setLocationOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [selectedSlot, setSelectedSlot] = useState(undefined);
  const [selectedSlotForEdit, setSelectedSlotForEdit] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [form] = Form.useForm();
  const loc = useLocation();

  const reseAllFieldData = () => {
    setLocationId("");
    form.resetFields();
  };

  // const handleChangeStatus = (value: string) => {
  //   setStatus(value);
  // };

  const getTimeSlot = useCallback(async () => {
    setSlotData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/dm-time-slot/all` +
          (locationId ? `?serviceLocation=${locationId}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setSlotData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setSlotData({ loading: false, data: [] });
        console.error("Slot: Error", err);
      });
  }, [locationId]);
  //

  const getLocationOptions = useCallback(async (val?: string) => {
    setLocationOptions({ loading: true, list: [] });

    const res = await axios.get(
      `${process.env.REACT_APP_RIDER_API}/admin/service-location/all` +
        (val ? `?name=${val}` : ``),
      {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );
    setLocationOptions({
      loading: false,
      list: res?.data?.serviceLocations?.map((location) => {
        return {
          value: location?.name,
          label: location?.name,
        };
      }),
    });
  }, []);

  const onDelete = async (id, val: any) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_RIDER_API}/admin/dm-time-slot`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getTimeSlot();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "locations") getLocationOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getLocationOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedSlot(undefined);
      setSelectedSlotForEdit(undefined);
    }
  }, [selectedSlot, selectedSlotForEdit, visible]);

  useEffect(() => {
    setSelectedSlot(undefined);
    setSelectedSlotForEdit(undefined);
  }, [visible]);

  useEffect(() => {
    getTimeSlot();
    getLocationOptions();
  }, [getTimeSlot, getLocationOptions]);

  const onClose = () => {
    setSelectedSlot(null);
    setSelectedSlotForEdit(null);
    getTimeSlot();
  };

  return (
    <React.Fragment>
      <TopHeading {...slotData?.data?.totalElements} refetch={getTimeSlot} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="location_search">
            <Select
              allowClear
              showSearch
              placeholder="Filter by Location"
              optionFilterProp="children"
              onChange={(val) => setLocationId(val)}
              onSearch={(e) => handleSearch(e, "locations")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {locationOptions.list.length ? (
                <Option value={""}>All Location</Option>
              ) : undefined}
              {locationOptions.list.map((location, i) => (
                <Option value={location.value} key={i}>
                  {location.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Slot</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Time</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {slotData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {slotData?.data?.timeSlots?.length ? (
                    slotData?.data?.timeSlots?.map((slot: any, index: any) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedSlot(slot)}
                        >
                          <div className="single-product">
                            <span className="name">
                              {slot?.serviceLocation}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {moment(slot?.date).format("ll")}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {slot?.fromHour} -{" "}
                              {slot?.toHour}
                            </span>
                          </div>
                          <div className="single-product">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked={slot?.isActive}
                              onChange={(val, e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onDelete(slot?.id, val);
                              }}
                              loading={
                                confirmLoading && slot?.id === confirmLoading
                              }
                            />
                          </div>
                          <div className="single-product">
                            <button
                              className="btn btn-sm btn-warning mx-1"
                              onClick={() => setSelectedSlotForEdit(slot)}
                            >
                              <EditOutlined />
                            </button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Slots" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedSlotForEdit ? "Edit Slot" : "Slot Details"}
            width={selectedSlotForEdit ? 500 : 600}
            onClose={onClose}
            visible={selectedSlot || selectedSlotForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedSlotForEdit ? (
              <AddTimeSlot
                visibleData={selectedSlotForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <TimeSlotDetails TimeSlotDetails={selectedSlot} />
            )}
          </Drawer>

          <PaginationTwo
            {...slotData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default TimeSlotList;
